export const WIDGET_SETTINGS_WIDGET_NAME_LIMIT: number = 100;
